<div class="main-container">
    <div class="row p-0 m-0">
        <div class="col-lg-6 col-md-6 d-none d-md-block p-0 m-0">
            <app-slider/>
        </div>
        <div class="col-lg-6 col-md-6 col-12 p-0 m-0">
             <router-outlet/>
        </div>
    </div>
</div>